__turbopack_context__.v({
  "CardPriceTag": "ProductCardSearch-module__shCekW__CardPriceTag",
  "CardReviewText": "ProductCardSearch-module__shCekW__CardReviewText",
  "DiscountTag": "ProductCardSearch-module__shCekW__DiscountTag",
  "ProductCard": "ProductCardSearch-module__shCekW__ProductCard",
  "active": "ProductCardSearch-module__shCekW__active",
  "addToCartBtn": "ProductCardSearch-module__shCekW__addToCartBtn",
  "attribute": "ProductCardSearch-module__shCekW__attribute",
  "attributes": "ProductCardSearch-module__shCekW__attributes",
  "brandButton": "ProductCardSearch-module__shCekW__brandButton",
  "button": "ProductCardSearch-module__shCekW__button",
  "buttons": "ProductCardSearch-module__shCekW__buttons",
  "buttonsContainer": "ProductCardSearch-module__shCekW__buttonsContainer",
  "cardBody": "ProductCardSearch-module__shCekW__cardBody",
  "cardButton": "ProductCardSearch-module__shCekW__cardButton",
  "cardImage": "ProductCardSearch-module__shCekW__cardImage",
  "cardPriceTag": "ProductCardSearch-module__shCekW__cardPriceTag",
  "cardReviewText": "ProductCardSearch-module__shCekW__cardReviewText",
  "cardTextContents": "ProductCardSearch-module__shCekW__cardTextContents",
  "cardTitle": "ProductCardSearch-module__shCekW__cardTitle",
  "cardTop": "ProductCardSearch-module__shCekW__cardTop",
  "cart": "ProductCardSearch-module__shCekW__cart",
  "comingSoon": "ProductCardSearch-module__shCekW__comingSoon",
  "count": "ProductCardSearch-module__shCekW__count",
  "discountTag": "ProductCardSearch-module__shCekW__discountTag",
  "freeDeliveryTag": "ProductCardSearch-module__shCekW__freeDeliveryTag",
  "full": "ProductCardSearch-module__shCekW__full",
  "higherQuantity": "ProductCardSearch-module__shCekW__higherQuantity",
  "icon": "ProductCardSearch-module__shCekW__icon",
  "image": "ProductCardSearch-module__shCekW__image",
  "lg": "ProductCardSearch-module__shCekW__lg",
  "lg2": "ProductCardSearch-module__shCekW__lg2",
  "loading": "ProductCardSearch-module__shCekW__loading",
  "md": "ProductCardSearch-module__shCekW__md",
  "message": "ProductCardSearch-module__shCekW__message",
  "outOfStock": "ProductCardSearch-module__shCekW__outOfStock",
  "outOfStockText": "ProductCardSearch-module__shCekW__outOfStockText",
  "overlay": "ProductCardSearch-module__shCekW__overlay",
  "popIn": "ProductCardSearch-module__shCekW__popIn",
  "popOut": "ProductCardSearch-module__shCekW__popOut",
  "preOrderText": "ProductCardSearch-module__shCekW__preOrderText",
  "prePrice": "ProductCardSearch-module__shCekW__prePrice",
  "price": "ProductCardSearch-module__shCekW__price",
  "quantityBtn": "ProductCardSearch-module__shCekW__quantityBtn",
  "rating": "ProductCardSearch-module__shCekW__rating",
  "removeBtn": "ProductCardSearch-module__shCekW__removeBtn",
  "removeButton": "ProductCardSearch-module__shCekW__removeButton",
  "reverse": "ProductCardSearch-module__shCekW__reverse",
  "sm": "ProductCardSearch-module__shCekW__sm",
  "spin": "ProductCardSearch-module__shCekW__spin",
  "top": "ProductCardSearch-module__shCekW__top",
  "wishlist": "ProductCardSearch-module__shCekW__wishlist",
  "xl": "ProductCardSearch-module__shCekW__xl",
  "xs": "ProductCardSearch-module__shCekW__xs",
});
